import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Constants } from 'src/app/models/constants';

@Component({
  selector: 'qr-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnInit {
  @Input() active: number = 1; // Página actualmente seleccionada
  @Input() totalPages: number = 1; // Cantidad total de páginas
  @Output() paginationChange: EventEmitter<number> = new EventEmitter<number>();

  isPreviousPageDisabled: boolean = false;
  isFirstPageDisabled: boolean = false;
  isNextPageDisabled: boolean = false;
  isLastPageDisabled: boolean = false;

  readonly ARROW_LEFT = Constants.ICONS.ARROW_LEFT;
  readonly ARROW_RIGHT = Constants.ICONS.ARROW_RIGHT;
  readonly ARROW_FIRST_PAGE = Constants.ICONS.ARROW_FIRST_PAGE;
  readonly ARROW_LAST_PAGE = Constants.ICONS.ARROW_LAST_PAGE;

  ICON_COLOR_GREY_700 = 'grey-700';
  ICON_COLOR_GREY_300 = 'grey-300';

  pagesArray: number[] = [];
  paginationStart: number = 1; // Donde arranca la paginación
  paginationEnd: number = 5; // Donde termina la paginación
  NUMBER_VISIBLE_BUTTONS: number = 5; // Cantidad de botones de página que se muestran

  ngOnInit(): void {
    this.generateArrayOfPages();
    this.updateButtonStatus();
  }

  select(item: number): void {
    this.active = item;
    this.paginationChange.emit(this.active);
    this.updateButtonStatus();
  }

  navigatePreviousPage(): void {
    if (this.active != 1) {
      this.active = this.active - 1;
      this.paginationChange.emit(this.active);
      this.updateButtonStatus();
    }
  }

  navigateNextPage(): void {
    if (this.active <= this.totalPages) {
      this.active = this.active + 1;
      this.paginationChange.emit(this.active);
      this.updateButtonStatus();
    }
  }

  navigateToFirstPage(): void {
    if (this.active != 1) {
      this.active = 1;
      this.paginationChange.emit(this.active);
      this.updateButtonStatus();
    }
  }

  navigateToLastPage(): void {
    if (this.active != this.totalPages) {
      this.active = this.totalPages;
      this.paginationChange.emit(this.active);
      this.updateButtonStatus();
    }
  }

  updateButtonStatus(): void {
    if (this.active == 1 || this.active < 1) {
      this.isPreviousPageDisabled = true;
      this.isFirstPageDisabled = true;
    } else {
      this.isPreviousPageDisabled = false;
      this.isFirstPageDisabled = false;
    }
    if (this.active == this.totalPages || this.active > this.totalPages) {
      this.isNextPageDisabled = true;
      this.isLastPageDisabled = true;
    } else {
      this.isNextPageDisabled = false;
      this.isLastPageDisabled = false;
    }

    // Cálculos de páginas a mostrar
    const BASE_NUMBER_PAGINATION =
      this.active % 5
        ? Math.floor(this.active / this.NUMBER_VISIBLE_BUTTONS)
        : Math.floor((this.active - 1) / this.NUMBER_VISIBLE_BUTTONS);
    this.paginationStart =
      BASE_NUMBER_PAGINATION * this.NUMBER_VISIBLE_BUTTONS + 1;
    this.paginationEnd = this.paginationStart + 5;

    const LAST_SEGMENT_PAGINATION =
      this.totalPages % 5
        ? Math.floor(this.totalPages / this.NUMBER_VISIBLE_BUTTONS)
        : Math.floor((this.totalPages - 1) / this.NUMBER_VISIBLE_BUTTONS);

    if ((this.paginationStart - 1) / 5 == LAST_SEGMENT_PAGINATION) {
      if (this.paginationEnd - 1 > this.totalPages) {
        let diffToSlice = this.paginationEnd - this.totalPages;
        this.paginationEnd = this.paginationEnd - diffToSlice + 1;
      }
    }

    this.generateArrayOfPages();
  }

  generateArrayOfPages(): void {
    this.pagesArray = [];
    for (let i = this.paginationStart; i < this.paginationEnd; i++) {
      this.pagesArray.push(i);
    }
  }
}
